import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context";
import Modal from "../Modal/Modal";
import { useLocation } from "react-router";
import ContractInfo from "../../ContractInfo";
import styles from "./Generator.module.scss";
import { Character } from "./Generator";

const Gminator = ({ character }: { character: Character }) => {
  const [extraPoints, setExtraPoints] = useState(false);
  const [isModalActive, setIsModalActive] = useState(false);
  const [displayConnectModal, setConnectModal] = useState(false);
  const [error, setError] = useState<{ message: string; status: number }>();
  const {
    wallet,
    connect,
    sign,
    userImages,
    saveUserImages,
    signature,
    twitterUser,
    connectTwitter,
    getTwitterUser,
  } = useContext(AppContext);
  const { search } = useLocation();

  const saveUser = async (newTwitterCode: string) => {
    const response = await window.fetch(
      `${ContractInfo[window.chain].backendUrl}/users`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          signature,
          twitterCode: newTwitterCode,
        }),
      }
    );
    if (!response.ok) {
      setError({
        status: response.status,
        message: (await response.json()).message,
      });
    }
    await getTwitterUser();
    await setIsModalActive(true);
  };

  const saveUserPfp = async (signature: string) => {
    try {
      const response = await fetch(
        `${ContractInfo[window.chain].backendUrl}/pfp`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            signature,
            ...character,
          }),
        }
      );
      const images = (await response.json()).images || [];
      await saveUserImages(images);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(search);
    const newTwitterCode = params.get("code") || "";
    if (newTwitterCode) {
      connect();
      if (signature) {
        saveUser(newTwitterCode);
      }
    }
  }, [search, signature]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (signature) {
      saveUserPfp(signature);
    }
  }, [signature]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <button
        className={styles.primaryButton}
        onClick={() => {
          if (signature) {
            saveUserPfp(signature);
          }
          if (window.ethereum) {
            setIsModalActive(true);
          } else {
            setConnectModal(true);
          }
        }}
      >
        Earn
      </button>
      <Modal
        isActive={isModalActive}
        onClose={() => setIsModalActive(false)}
        title={<div>collect gm points</div>}
        content={
          <div className="container">
            <span className="step-text">Step 1:&nbsp;</span>
            <span className={!!wallet ? "modal-strike-through" : ""}>
              <span className="step-action step-1-action" onClick={connect}>
                Connect Your Wallet
              </span>
            </span>
            &nbsp;
            {!!wallet ? "✅" : "❎"}
            <br />
            <br />
            <div className={!wallet ? "step-disabled" : ""}>
              <span className="step-text">Step 2:&nbsp;</span>
              <span className={!!signature ? "modal-strike-through" : ""}>
                <span
                  className="step-action step-2-action"
                  onClick={
                    wallet
                      ? async () => {
                          const signature = await sign();
                          await saveUserPfp(signature);
                        }
                      : () => {}
                  }
                >
                  Sign Terms and Conditions
                </span>
              </span>
              &nbsp;
              {!!signature ? "✅" : "❎"}
            </div>
            <br />
            <div className={!wallet || !signature ? "step-disabled" : ""}>
              <span className="step-text">Step 3:&nbsp;</span>
              <span
                className={
                  !!twitterUser?.twitterId ? "modal-strike-through" : ""
                }
              >
                <span
                  className="step-action step-3-action"
                  onClick={wallet && signature ? connectTwitter : () => {}}
                >
                  Connect your Twitter
                </span>
              </span>
              &nbsp;
              {!!twitterUser?.twitterId ? "✅" : "❎"}&nbsp;
              <a
                className="twitter-name-modal"
                href={`https://twitter.com/${twitterUser?.twitterUsername}`}
              >
                {twitterUser?.twitterName}
              </a>
            </div>
            <br />
            {error && error.message && (
              <div>
                {!twitterUser?.twitterName && (
                  <div className="step-text">{error.message}</div> // only display error if user's twitter account fetch failed
                )}
                {error.status === 409 && (
                  <div>
                    <span>
                      Please contact the team if you would like to change your
                      registered wallet. Note: doing so will mean losing rewards
                      on your existing wallet.
                    </span>
                  </div>
                )}
                <br />
              </div>
            )}
            {!!twitterUser?.twitterId ? (
              <div>
                <div className={styles.congratulations}>Congratulations!</div>
                <div>
                  You are now registered on the Reply Guys platform!
                  <a
                    href="https://twitter.com/intent/tweet?text=Just%20signed%20up%20for%20@replyguys_nft%20GM-inator%20%F0%9F%A4%A9%20on%20https://replyguys.io/gm-inator"
                    target="_blank"
                    rel="noreferrer"
                  >
                    &nbsp;Tweet about it&nbsp;
                  </a>
                  and start earning points!
                </div>
                <br />
                <button
                  className={styles.primaryButton}
                  onClick={() => setExtraPoints(!extraPoints)}
                >
                  {!extraPoints ? "Get Extra Points" : "Stay broke"}
                </button>
                <br />
                <br />
              </div>
            ) : (
              <></>
            )}
            {extraPoints && (
              <>
                <div className={!twitterUser?.twitterId ? "step-disabled" : ""}>
                  <span className="step-text">Step 4:&nbsp;</span>
                  <span
                    className={
                      !!twitterUser?.bioSince ? "modal-strike-through" : ""
                    }
                  >
                    <span
                      className="step-action step-4-action"
                      onClick={
                        !!twitterUser?.twitterId
                          ? () =>
                              window.location.assign(
                                `https://twitter.com/${twitterUser?.twitterUsername}`
                              )
                          : () => {}
                      }
                    >
                      Change your twitter bio to include "@replyguys_nft" in it
                    </span>
                  </span>
                  &nbsp;
                  {!!twitterUser?.bioSince ? "✅" : "❎"}&nbsp;
                  <a
                    className="twitter-name-modal"
                    href={`https://twitter.com/${twitterUser?.twitterUsername}`}
                  >
                    {twitterUser?.twitterName}
                  </a>
                </div>
                <br />
                <div className={!twitterUser?.twitterId ? "step-disabled" : ""}>
                  <span className="step-text">Step 5:&nbsp;</span>
                  <span
                    className={
                      !!twitterUser?.pfpSince ? "modal-strike-through" : ""
                    }
                  >
                    <span
                      className="step-action step-5-action"
                      onClick={
                        !!twitterUser?.twitterId
                          ? () =>
                              window.location.assign(
                                `https://twitter.com/${twitterUser?.twitterUsername}`
                              )
                          : () => {}
                      }
                    >
                      Change your twitter pfp to one of the Reply Guys below:
                    </span>
                  </span>
                  &nbsp;
                  {!!twitterUser?.pfpSince ? "✅" : "❎"}&nbsp;
                  <a
                    className="twitter-name-modal"
                    href={`https://twitter.com/${twitterUser?.twitterUsername}`}
                  >
                    {twitterUser?.twitterName}
                  </a>
                  <br />
                  <br />
                  <div className="columns is-centered"></div>
                  <div className="columns">
                    <div className="column">
                      {userImages.map((image) => (
                        <img
                          alt="Reply Guys Mascot"
                          className="modal-silhouette"
                          key={image}
                          src={image}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        }
      />
      <Modal
        isActive={displayConnectModal}
        title="Connect Wallet"
        content="Please use a browser with a web3 wallet"
        onClose={() => setConnectModal(false)}
      />
    </>
  );
};

export default Gminator;
